import { Button } from '@lmc/ui-kit'
import type { ReactNode } from 'react'

type DownloadFileProps = {
  fileUrl: string
  fileName: string
  children: ReactNode
}

const DownloadFile = ({ fileUrl, fileName, children }: DownloadFileProps) => {
  const handleDownload = () => {
    const link = document.createElement('a')
    link.href = fileUrl
    link.target = '_blank'
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <Button variant="text" onClick={handleDownload}>
      {children}
    </Button>
  )
}

export default DownloadFile
